export const UPDATE_ORGANISATIONS = 'UPDATE_ORGANISATIONS'
